<mat-card appearance="raised" *ngFor="let day of byDays" class="date-container mat-elevation-z1">
  <mat-card-title class="date-header primary">{{ day.date|date:'fullDate'|titlecase }}</mat-card-title>

  <div class="items">
    <div *ngFor="let presence of day.items; let last = last" class="item" [ngClass]="{
      'attente': presence.attente,
      'unselected': !reservationService.isPresenceSelected(presence),
      'canceling':presence.askCancel ,
      'error': presence.error
    }">
      <span class="time" [ngClass]="{'multiple': !!presence.startTime2}">
        <ng-container *ngIf="presence.showTimes">
          {{ presence.startTime }} - {{ presence.endTime }}
          <span *ngIf="presence.startTime2">{{ presence.startTime2 }} - {{ presence.endTime2 }}</span>
        </ng-container>
      </span>
      <span class="color" [style.backgroundColor]="presence.color"></span>


      <span class="pres-container">
        <span class="pres">
          <span class="pres-title">
            {{ presence.title }}
            <mat-icon *ngIf="!!presence.attenteDetail" [matTooltip]="presence.attenteDetail.message"
              class="alert-liste-attente" color="warn"
              matTooltipClass="tooltip-pre-line tooltip-large">feedback</mat-icon>
          </span>
          <span *ngIf="presence.attente" class="attente">

            <ng-container *ngTemplateOutlet="attenteChoice; context: { presence, type:'presence'}"></ng-container>
          </span>

        </span>

        <ul *ngIf="presence.activities?.length>0" class="detail-activites">
          <li *ngFor="let activity of presence.activities" class="act-detail">
            <i class="icon icodomino-activite " aria-label="Activité"></i>
            <span class="act-title">
              {{activity.name}}
            </span>
            <span *ngIf="activity.attente" class="attente">
              <ng-container
                *ngTemplateOutlet="attenteChoice; context: {presence , activity, type:'activite'}"></ng-container>
            </span>

          </li>
        </ul>
      </span>

      <span *ngIf="presence.askCancel" class="canceling">
        <mat-icon style="margin-right: 5px">{{ 'reservation.state_icon.canceling'|trans }}</mat-icon>
        <span [innerHTML]="'reservation.summary.canceling'|trans "></span>
      </span>
      <span *ngIf="presence.error" class="error-icon" [matTooltip]="presence.error.errorMessage">
        <mat-icon color="warn">error_outline</mat-icon>
      </span>
    </div>
  </div>
</mat-card>

<ng-template #attenteChoice let-presence="presence" let-activity="activity" let-type="type">

  <!-- Presence qui peut être validée seule -->
  @if (type==='presence' && presence.attenteDetail?.canDuplicateWithoutActivity) {
  <mat-checkbox *ngIf="planningData.currentPeriode.gestionListeAttente === 'demande'; else autoValidatePres"
    [checked]="presence.attenteDetail.addSinglePres === 1" (change)="onToggleSaveSinglePres(presence , $event)">
    @if (presence.attenteDetail?.fullPlages?.length>0){
    <!-- Inscrire sur liste d'attente <b>sans l'activité</b> -->
    <span
      [innerHTML]="'reservation.summary.liste_attente_options.ask.presence_sans_activite_to_liste_attente'|trans |safe"></span>
    } @else {
    <!-- Réserver <b>sans l'activité</b> -->
    <span
      [innerHTML]="'reservation.summary.liste_attente_options.ask.presence_dispo_sans_activite'|trans |safe "></span>
    }
  </mat-checkbox>


  <!-- Presence qui ne peut pas être validée seule -->
  } @else if (type==='presence' && !presence.attenteDetail?.canDuplicateWithoutActivity ){

  <mat-checkbox *ngIf="planningData.currentPeriode.gestionListeAttente === 'demande'; else autoAttente"
    [checked]="presence.attente === 1" (change)="onToggleAttente(presence , null, $event)">
    @if(presence.attenteDetail?.fullActivities?.length>0){
    <!-- Inscrire l'ensemble sur liste d'attente -->
    <span
      [innerHTML]="'reservation.summary.liste_attente_options.ask.presence_avec_activite_to_liste_attente'|trans |safe"></span>
    } @else {
    <!-- Inscrire sur liste d'attente -->
    <span [innerHTML]="'reservation.summary.liste_attente_options.ask.presence_to_liste_attente'|trans|safe "></span>
    }
  </mat-checkbox>

  <!-- Activite mais on affiche ceci seulement si la présence est réservable seule -->
  } @else if (type==='activite' && presence.attenteDetail?.canDuplicateWithoutActivity ) {

  <mat-checkbox *ngIf="planningData.currentPeriode.gestionListeAttente === 'demande'; else autoAttente"
    [checked]="activity.attente === 1" (change)="onToggleAttente(presence ,activity , $event)">
    <!-- Inscrire l'activité sur liste d'attente -->
    <span [innerHTML]="'reservation.summary.liste_attente_options.ask.activite_to_liste_attente'|trans|safe"></span>

  </mat-checkbox>

  }

</ng-template>

<ng-template #autoAttente>
  <!-- Liste d'attente -->
  <span [innerHTML]="'reservation.summary.liste_attente_options.auto.normal'|trans|safe "></span>
</ng-template>

<ng-template #autoValidatePres>
  <!-- Présence réservée <b>sans activité</b>+ -->
  <span [innerHTML]="'reservation.summary.liste_attente_options.auto.presence_sans_activite'|trans |safe"></span>
</ng-template>